import { SBAPI } from '@supplement-bacon/react-toolkit/utils'
import { TableParams } from '@supplement-bacon/sb-table-filters'
import { Policy } from '../../models/business/Policy'
import { POLICIES_URL } from '../../utils/urls'

const fetchPolicies = (params: TableParams) =>
  SBAPI.FetchPaginated<Policy[]>(POLICIES_URL, params)

const fetchPolicyById = (id: number, params?: TableParams) =>
  SBAPI.Fetch<Policy>(`${POLICIES_URL}/${id}`, params)

const createPolicy = (policy: Policy) => SBAPI.Post(POLICIES_URL, policy)

const updatePolicy = (policy: Policy) =>
  SBAPI.Post(`${POLICIES_URL}/${policy.id}`, policy)

const deletePolicy = (policy: Policy) =>
  SBAPI.Delete(`${POLICIES_URL}/${policy.id}`)

export {
  createPolicy,
  deletePolicy,
  fetchPolicies,
  fetchPolicyById,
  updatePolicy,
}
